<template>
  <div id="app">
    <mol-header v-if="$route.params.organizationId" />
    <transition name="page" mode="out-in">
      <router-view />
    </transition>
    <mol-footer />
  </div>
</template>

<script>
import MolHeader from "@/components/header.vue";
import MolFooter from "@/components/footer.vue";
import { axiosInstance as axios } from "@/main";

export default {
  name: "app",
  data() {
    return {
      shouldSendLocation: true
    };
  },
  computed: {
    session() {
      return this.$store.getters.session;
    },
    user() {
      return this.$store.getters.user;
    },
    organization() {
      return this.$store.getters.get_organization;
    },
    organizationId() {
      return this.$route.params.organizationId;
    }
  },
  watch: {
    organization(val, oldVal) {
      if (!oldVal || oldVal.id !== val.id) {
        this.attachCustomCss(val);
        this.attachCustomJs(val);
        this.attachCustomJsHeader(val);
      }
    },
    organizationId() {
      this.fetchOrganizacao();
    },
    async $route(to) {
      if (this.$route.name !== "Institution") {
        if (!this.session) {
          await this.getSession();
        }

        if (this.$route.name !== "index" && this.$route.name !== "finish") {
          this.$store.dispatch(
            "set_type",
            this.$route.fullPath.includes("consulta")
              ? "consulta"
              : this.$route.fullPath.includes("exame")
              ? "exame"
              : "retorno"
          );
        }

        this.$nextTick(this.set_params.bind(this));

        this.getLocation();

        axios
          .post(
            `${this.$serverHost}configs/sessao/passo`,
            {
              nome: to.name,
              params: to.params,
              query: to.query
            },
            {
              headers: {
                "X-Token-Sessao": this.session,
                ...(this.$store.getters.token
                  ? { Authorization: `Bearer ${this.$store.getters.token}` }
                  : {})
              }
            }
          )
          .catch(console.error);
      }
    }
  },
  async mounted() {
    this.fetchOrganizacao();

    await this.$store.dispatch("load_urls");

    if (this.$route.name !== "index" && this.$route.name !== "finish") {
      this.$store.dispatch(
        "set_type",
        this.$route.fullPath.includes("consulta")
          ? "consulta"
          : this.$route.fullPath.includes("exame")
          ? "exame"
          : "retorno"
      );
    }

    try {
      if (!this.session) {
        await this.getSession();
      }
    } catch (e) {
      console.log(e);
    }

    if (this.user.nome && this.$route.name !== "Institution") {
      let payload = {
        url: this.$serverHost
      };

      this.$store.dispatch("send_user", payload);
    }

    this.$nextTick(function() {
      window.addEventListener("resize", this.getWindowWidth);
      window.addEventListener("resize", this.getWindowHeight);

      //Init
      this.getWindowWidth();
      this.getWindowHeight();
    });
  },
  methods: {
    fetchOrganizacao() {
      if (this.organizationId) {
        this.$store.dispatch("load_organization", { id: this.organizationId });
      }
    },
    attachCustomCss(organizacao) {
      if (organizacao && organizacao.id) {
        const oldCss = document.getElementById("custom-css");

        if (oldCss) {
          document.head.removeChild(oldCss);
        }

        const customCss = document.createElement("link");
        customCss.href = `${this.$serverHost.replace(
          "/api/",
          ""
        )}/api/configs/organizacoes/${organizacao.id}/custom-style.css`;
        customCss.rel = "stylesheet";
        customCss.id = `custom-css`;
        document.head.appendChild(customCss);
      }
    },
    attachCustomJs(organizacao) {
      if (organizacao && organizacao.id) {
        const oldJs = document.getElementById("custom-js");

        if (oldJs) {
          document.body.removeChild(oldJs);
        }

        const customJs = document.createElement("script");
        customJs.src = `${this.$serverHost.replace(
          "/api/",
          ""
        )}/api/configs/organizacoes/${organizacao.id}/custom-script.js`;
        customJs.type = "application/javascript";
        customJs.id = "custom-js";
        document.body.appendChild(customJs);
      }
    },
    attachCustomJsHeader(organizacao) {
      if (organizacao && organizacao.id) {
        const oldJs = document.getElementById("custom-js-header");

        if (oldJs) {
          document.head.removeChild(oldJs);
        }

        const customJs = document.createElement("script");
        customJs.src = `${this.$serverHost}configs/organizacoes/${organizacao.id}/custom-script-header.js`;
        customJs.type = "application/javascript";
        customJs.id = "custom-js-header";
        document.head.appendChild(customJs);
      }
    },
    set_params() {
      this.$store.dispatch("set_params", this.$route.params);
      this.$store.dispatch("set_query");
    },
    getWindowWidth() {
      this.$store.dispatch("set_width", document.documentElement.clientWidth);
    },
    async sendLocation(position) {
      await this.$store.dispatch("sendLocation", {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });

      this.shouldSendLocation = false;
    },
    getLocation() {
      if (!this.shouldSendLocation) {
        return;
      }

      let askedForLocation =
        sessionStorage.getItem("mol.geolocation.asked") === "true";

      if (!askedForLocation) {
        sessionStorage.setItem("mol.geolocation.asked", "true");

        navigator.geolocation.getCurrentPosition(
          position => this.sendLocation(position),
          error => {
            if (error.code === error.PERMISSION_DENIED) {
              this.shouldSendLocation = false;
            } else {
              console.log(error);
            }
          }
        );
      }
    },
    async getSession() {
      if (this.$route.params.organizationId) {
        let response = await axios.get(`${this.$serverHost}configs/sessao`, {
          headers: { "X-Organizacao-ID": this.$route.params.organizationId }
        });

        this.$store.dispatch("set_session", response.data.token);
      }
    },
    logoff() {
      const mensagem = "Seu login expirou. Por favor, faça login novamente.";
      this.$bvToast.toast(mensagem, {
        title: "Aviso",
        variant: "danger",
        autoHideDelay: 10000,
        appendToast: true
      });
      this.$store.dispatch("logoff");
      this.$router.push(`/index/${this.$route.params.organizationId}`);
    },
    getWindowHeight() {
      this.$store.dispatch("set_height", document.documentElement.clientHeight);
    }
  },
  destroy() {
    window.removeEventListener("resize", this.getWindowWidth);
    window.removeEventListener("resize", this.getWindowHeight);
  },
  components: { MolHeader, MolFooter }
};
</script>

<style>
#app {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Metropolis", "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #343a40;
  text-align: left;
  background-size: cover;
  background-position: top left;
  min-height: 100%;
}
</style>
